import React from "react";
import Icon, { ICON_TYPE_CLOSE } from "../../../Icon";
import "./NotificationItem.css";
import { getClassNames } from "../../../../utils";

const NotificationItem = ({
    id = null,
    subject = null,
    date = null,
    text = null,
    onClick = () => {},
}) => {
    const className = getClassNames("NotificationItem", {
        "NotificationItem__without-date": !date,
    });

    return (
        <div className={className}>
            <div className="notification__title">{subject}</div>
            {date && <div className="notification__date">{date}</div>}
            <div className="notification__description">{text}</div>
            <div
                className="notification__read"
                role="button"
                tabIndex={0}
                onClick={() => onClick(id, subject, date, text)}
                onKeyPress={onClick}
            >
                <Icon type={ICON_TYPE_CLOSE} />
            </div>
        </div>
    );
};


export default NotificationItem;
